import React, { useEffect, useState } from "react";
import { ProductFormValues, ProductVariationFormValues } from "api/productAPI";
import { Header, Form } from "semantic-ui-react";
import ColorSearch from "features/color/ColorSearch";
import { Size, Color } from "api/types";
import SizeDropdown from "features/size/SizeDropdown";
import VariationTable from "./VariationsTable";

interface VariationsFormSectionProps {
  item: ProductFormValues;
  onChange: Function;
  onVariationAdd: Function;
  onVariationRemoval: (
    id: number | undefined,
    color: string,
    size: Size
  ) => void;
}

const VariationsFormSection: React.FC<VariationsFormSectionProps> = ({
  item,
  onChange,
  onVariationAdd,
  onVariationRemoval,
}) => {
  const [color, setColor] = useState<Color | null>(null);
  const [size, setSize] = useState<Size>();
  const [variations, setVariations] = useState<ProductVariationFormValues[]>(
    []
  );

  useEffect(() => {
    setVariations(item.variations);
  }, [item]);

  const getPack = () => {
    if (size === "REGULAR") {
      return item.regularPack;
    } else if (size === "PLUS") {
      return item.plusPack;
    }
    return item.onesizePack;
  };

  const handleAddition = () => {
    const pack = getPack();
    if (pack && color && size) {
      onVariationAdd({
        color: color.name,
        size,
        pack: pack.name,
        packBreakdown: pack.breakdown,
      });
    }
  };

  return (
    <>
      <Header size="medium">Color / Size Variations</Header>
      <Form.Group>
        <ColorSearch
          label="Color"
          name="color"
          onSearch={setColor}
          value={color}
        />
        <SizeDropdown
          label="Size"
          name="size"
          onSelect={setSize}
          value={size}
          isOnesize={item.isOnesize}
        />
        <Form.Button
          type="submit"
          content="Add"
          onClick={handleAddition}
          color="twitter"
        />
      </Form.Group>
      <VariationTable variations={variations} onRemoval={onVariationRemoval} />
    </>
  );
};

export default VariationsFormSection;
